import { render, staticRenderFns } from "./dependentInclusionSearchHolders.vue?vue&type=template&id=1b7a7373&"
import script from "./dependentInclusionSearchHolders.vue?vue&type=script&lang=js&"
export * from "./dependentInclusionSearchHolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports